import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerReferralProgramClick } from "@nxplatform/customer-noauth/slices/customer-noauth.slice";
import { changeCustomerData } from "@nxplatform/geo-data/slices/ip-data.slice";
import { DEV_FEATURE_ACTIVATE_URL_PARAM, getCookie, expireCookie, setCookie } from "@nxplatform/helpers/common";
import { CustomerBasicModal, RegistrationStepForm } from "@nxplatform/platform-entities/customer/customer-enum-types";
import { selectIsReferralProgramEnabled, enableReferralProgram } from "@nxplatform/platform-settings/brand-settings.slice";
import { customerOpenBasicModal } from "@nxplatform/store-shared/customer/shared-customer-actions";
import { selectCustomerBasicModalStatus } from "@nxplatform/store-shared/customer/shared-customer-selectors";
import { SessionStorage, AppStorage } from "@service/api-client/http/helpers/AppStorage";
import { getQueryParam } from "./query.hook.js";
import { selectIsReferralProgramByPlatformEnabled } from "@nxplatform/platform-settings/platform-settings.selectors";
const referralInfoStorageKey = "referralInfo";
const referralCookieCode = "referralCookie";
const referralProgramActivateParam = "referralProgram";
const useReferralProgramHook = ({
  appReady = true
} = {}) => {
  const dispatch = useDispatch();
  const currentModal = useSelector(selectCustomerBasicModalStatus);
  const enabledByCMS = useSelector(selectIsReferralProgramEnabled);
  const enabledByPlatform = useSelector(selectIsReferralProgramByPlatformEnabled);
  const allowDisabledReferralProgram = SessionStorage.get(
    DEV_FEATURE_ACTIVATE_URL_PARAM
  ) === referralProgramActivateParam;
  const referralClickUserId = getQueryParam().get("id");
  const referralClickCode = getQueryParam().get("ref_code");
  const referralLinkPresent = referralClickUserId && referralClickCode;
  const savedReferral = AppStorage.get(referralInfoStorageKey);
  const savedReferralCode = getCookie(referralCookieCode);
  const referralInfo = {
    id: Number(referralClickUserId),
    refCode: referralClickCode
  };
  useEffect(() => {
    if (appReady && referralLinkPresent) {
      AppStorage.set(referralInfoStorageKey, { ...referralInfo });
      const expires = expireCookie(6e4 * 60 * 24);
      setCookie(referralCookieCode, referralClickCode, { expires });
      dispatch(registerReferralProgramClick({
        ...referralInfo,
        unique: !savedReferral
      }));
      dispatch(customerOpenBasicModal(CustomerBasicModal.register));
    }
  }, [appReady, referralLinkPresent]);
  useEffect(() => {
    if (appReady && savedReferralCode && currentModal === CustomerBasicModal.register) {
      const referralCodeFromCookie = getCookie(referralCookieCode);
      dispatch(changeCustomerData({
        [RegistrationStepForm.promoCode]: referralCodeFromCookie
      }));
    }
  }, [appReady, savedReferralCode, currentModal]);
  useEffect(() => {
    if (allowDisabledReferralProgram && enabledByPlatform && !enabledByCMS) {
      dispatch(enableReferralProgram());
    }
  }, [allowDisabledReferralProgram, enabledByPlatform, enabledByCMS]);
};
export {
  referralCookieCode,
  referralInfoStorageKey,
  referralProgramActivateParam,
  useReferralProgramHook
};
